import { render, staticRenderFns } from "./RecalculatePlansPopup.vue?vue&type=template&id=ba1d99c6&scoped=true"
import script from "./RecalculatePlansPopup.vue?vue&type=script&lang=js"
export * from "./RecalculatePlansPopup.vue?vue&type=script&lang=js"
import style0 from "./RecalculatePlansPopup.vue?vue&type=style&index=0&id=ba1d99c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1d99c6",
  null
  
)

export default component.exports